import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 180
    },
    vaccinationMedicationInfoBox: {
      justifyContent: 'space-between'
    },
    filtersCard: {
      margin: theme.spacing(1),
      marginLeft: 0,
      maxWidth: '85%',
      minWidth: '35%'
    },
    filtersCardHeader: {
      paddingBottom: 0,
      paddingTop: 0
    },
    filtersCardContent: {
      paddingTop: 0
    },
    filtersBox: {
      display: 'flex',
      justifyContent: 'left'
    },
    animalTypeTabs: {
      background: colors.defaultGrey,
      backgroundColor: '#eceff1!important'
    },
    refreshIconGrid: {
      textAlign: 'right'
    }
  });
});
